/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalRequest = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SuperagentResponse = require('./SuperagentResponse');

var _LambdaResponse = require('./LambdaResponse');

var _Request2 = require('./Request');

var _Action = require('./Action');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _MissingLocalLambdaExecWrapperException = require('./Exception/MissingLocalLambdaExecWrapperException');

var _MissingLambdaLocalPathException = require('./Exception/MissingLambdaLocalPathException');

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Resource request instance
 */
let LocalRequest = exports.LocalRequest = function (_Request) {
  _inherits(LocalRequest, _Request);

  function LocalRequest() {
    var _ref;

    _classCallCheck(this, LocalRequest);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = LocalRequest.__proto__ || Object.getPrototypeOf(LocalRequest)).call.apply(_ref, [this].concat(args)));
  }

  /**
   * @returns {String}
   * @private
   */


  _createClass(LocalRequest, [{
    key: '_buildEndpointUrl',
    value: function _buildEndpointUrl() {
      let endpoint = this._async ? LocalRequest.LOCAL_LAMBDA_ASYNC_ENDPOINT : LocalRequest.LOCAL_LAMBDA_ENDPOINT;

      if (this.baseUrl) {
        let urlParts = (0, _urlParse2.default)(this.baseUrl);
        let protocol = urlParts.protocol || 'http:';
        let baseUrl = `${protocol}//${urlParts.host}`;

        endpoint = baseUrl + endpoint;
      }

      return endpoint;
    }

    /**
     * @param {Function} callback
     * @returns {LocalRequest|*}
     */

  }, {
    key: '_send',
    value: function _send() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      let actionType = this._action.type;
      let securityService = this._action.resource.security;

      if (actionType === _Action.Action.LAMBDA) {
        let data = {
          lambda: this._action.source.original,
          payload: this.payload,
          method: this._method,
          context: {
            identity: {
              cognitoIdentityPoolId: securityService.token ? securityService.token.identityPoolId : null,
              cognitoIdentityId: securityService.token ? securityService.token.identityId : null,
              isAnonymous: securityService.token ? securityService.token.isAnonymous : true
            }
          }
        };

        if (typeof window === 'undefined') {
          if (!global.hasOwnProperty(LocalRequest.LAMBDA_EXEC_WRAPPER_KEY)) {
            throw new _MissingLocalLambdaExecWrapperException.MissingLocalLambdaExecWrapperException(LocalRequest.LAMBDA_EXEC_WRAPPER_KEY);
          }

          let localPath = this._action.source._localPath;

          if (!localPath) {
            throw new _MissingLambdaLocalPathException.MissingLambdaLocalPathException(data.lambda);
          }

          let execWrapper = global[LocalRequest.LAMBDA_EXEC_WRAPPER_KEY];

          execWrapper[this._async ? 'invokeAsync' : 'invoke'](localPath, data, (error, result) => {
            let resultData = {};

            if (this._async) {
              resultData.Status = 202;
            } else {
              resultData.Payload = result;
            }

            callback(new _LambdaResponse.LambdaResponse(this, error ? null : resultData, error));
          });
        } else {
          _superagent2.default.post(this._buildEndpointUrl()).send(data).end((error, response) => {
            callback(new _SuperagentResponse.SuperagentResponse(this, response, error));
          });
        }
      } else {
        var _constructor$useNativ;

        return (_constructor$useNativ = this.constructor.useNative())._send.apply(_constructor$useNativ, arguments);
      }

      return this;
    }

    /**
     * @returns {String}
     */

  }], [{
    key: 'LOCAL_LAMBDA_ENDPOINT',
    get: function get() {
      return '/_/lambda';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'LOCAL_LAMBDA_ASYNC_ENDPOINT',
    get: function get() {
      return '/_/lambda-async';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'LAMBDA_EXEC_WRAPPER_KEY',
    get: function get() {
      return '_deep_lambda_exec_';
    }
  }]);

  return LocalRequest;
}(_Request2.Request);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/LocalRequest.js
// module id = 428
// module chunks = 0